import { Button, Form, Input, List, Modal } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { useDeleteItemMutation, useItemsFine } from "../_actions/app/items";
import log from "cslog";
import { useCreateItem } from "../_actions/mutations/items";

function PresetSuggestions({
    trigger,
    record,
    filter_prefix = "filter[presets][qdb_creation_schema_id][_eq]",
    makePayload = () => {},
}) {
    const [open, setOpen] = useState(false);
    const { isSuccess, isLoading, data } = useItemsFine(
        "qdb_spotlight_suggestions",
        // `filter[presets][qdb_creation_schema_id][_eq]=${record?.id}`,
        `${filter_prefix}=${record?.id}`,
        !!record?.id && open
    );
    const [text, setText] = useState("");
    const [deletingIds, setDeletingIds] = useState(new Set());
    const mutationCreate = useCreateItem("qdb_spotlight_suggestions", () => {});
    const mutationDelete = useDeleteItemMutation();

    log.d(data, "preset suggestions in PSS");

    const addSuggestion = () => {
        if (text?.length > 3) {
            mutationCreate.mutate(makePayload(text));
            setText("");
        }
    };

    return (
        <div>
            <span onClick={() => setOpen(true)}>{trigger}</span>
            <Modal
                title={`"${record?.name || record?.title}" suggestions`}
                open={open}
                onCancel={() => setOpen(false)}
                onOk={() => setOpen(false)}
                onClose={() => setOpen(false)}
                okText="Done"
                cancelText="Close"
            >
                <Form layout="vertical">
                    <Form.Item label="Suggestion">
                        <Input
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            onPressEnter={addSuggestion}
                            placeholder="Enter suggestion"
                        />
                    </Form.Item>
                    <Button
                        type="primary"
                        onClick={addSuggestion}
                        loading={mutationCreate.isLoading}
                    >
                        Add
                    </Button>
                </Form>
                {isSuccess && data && (
                    <List
                        dataSource={data}
                        renderItem={(item) => (
                            <List.Item
                                actions={[
                                    <Button
                                        icon={<DeleteOutlined />}
                                        danger
                                        loading={deletingIds.has(item.id)}
                                        onClick={() => {
                                            setDeletingIds((prev) =>
                                                new Set(prev).add(item.id)
                                            );
                                            mutationDelete.mutate(
                                                {
                                                    collection:
                                                        "qdb_spotlight_suggestions",
                                                    id: item.id,
                                                },
                                                {
                                                    onSettled: () =>
                                                        setDeletingIds(
                                                            (prev) => {
                                                                const newSet =
                                                                    new Set(
                                                                        prev
                                                                    );
                                                                newSet.delete(
                                                                    item.id
                                                                );
                                                                return newSet;
                                                            }
                                                        ),
                                                }
                                            );
                                        }}
                                    ></Button>,
                                ]}
                            >
                                {item.label}
                            </List.Item>
                        )}
                        bordered
                        size="small"
                        style={{
                            marginTop: "15px",
                        }}
                    />
                )}
            </Modal>
        </div>
    );
}

export default PresetSuggestions;
